import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { acceptGoogleConsent, declineGoogleConsent } from "../lib/googleAds";

export function CookieBanner() {
  const { t } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("zejzen_cookie_ok")) setShow(true);
    const reopen = () => setShow(true);
    window.addEventListener("zejzen:show-cookies", reopen);
    return () => window.removeEventListener("zejzen:show-cookies", reopen);
  }, []);

  if (!show) return null;

  const accept = () => {
    acceptGoogleConsent();
    setShow(false);
  };

  const decline = () => {
    declineGoogleConsent();
    setShow(false);
  };

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-[70] bg-[#09090B] text-white border-t-2 border-[var(--zjz-accent)] px-4 sm:px-8 py-3 flex flex-wrap items-center justify-between gap-3"
    >
      <p className="font-badge text-[10px] sm:text-xs flex-1 min-w-[200px]">
        {t("cookieText")}{" "}
        <Link to="/datenschutz" className="underline hover:text-[var(--zjz-accent)] transition-colors duration-150" data-testid="cookie-privacy-link">
          Datenschutz
        </Link>
      </p>
      <div className="flex gap-2">
        <button
          onClick={decline}
          data-testid="cookie-decline-button"
          className="border border-white/40 text-white font-badge text-xs px-5 py-2 hover:bg-white hover:text-[#09090B] transition-colors duration-150"
        >
          {t("cookieDecline")}
        </button>
        <button
          onClick={accept}
          data-testid="cookie-accept-button"
          className="bg-[var(--zjz-accent)] text-white font-badge text-xs px-6 py-2 hover:bg-white hover:text-[#09090B] transition-colors duration-150"
        >
          {t("cookieAccept")}
        </button>
      </div>
    </div>
  );
}
